(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arc-product-description"] && !Shopify.designMode) return;
  try {
    function prepareArcSizeCharts(root) {
    root.querySelectorAll('details[id^="ArcSizing-"]').forEach((sizing) => {
      const chart = sizing.querySelector('.arc-size-chart');
      if (!chart || chart.querySelector('table')) return;
      const productId = sizing.id.slice('ArcSizing-'.length);
      const details = document.getElementById('ArcDetails-' + productId);
      const table = details && details.querySelector('table#size-guide');
      if (!table) return;
      const note = table.previousElementSibling;
      const heading = note && note.previousElementSibling;
      if (note && /^Garment measurements\b/i.test(note.textContent.trim())) {
        if (heading && /^SIZE\s*&\s*FIT\b/i.test(heading.textContent.trim())) {
          sizing.insertBefore(heading, chart);
        }
        sizing.insertBefore(note, chart);
      }
      chart.appendChild(table);
      chart.hidden = false;
      const fallback = sizing.querySelector('.arc-size-fallback');
      if (fallback) fallback.hidden = true;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareArcSizeCharts(document), { once: true });
  } else {
    prepareArcSizeCharts(document);
  }
  document.addEventListener('shopify:section:load', (event) => prepareArcSizeCharts(event.target));
  } catch(e) { console.error(e); }
})();

})();
